import { useMutation } from '@tanstack/react-query';
import { auth } from '../../../components/Auth/Auth.jsx';

const triggerScheduledSettings = async (deviceIds) => {
    const user = auth.currentUser;
    let token = '';

    if (user) {
        token = await user.getIdToken();
    }


    const response = await fetch(`${import.meta.env.VITE_API_URL}/api/v1/setting/refresh-scheduled`,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...(token && { 'Authorization': `Bearer ${token}` })
        },
        body: JSON.stringify({
            deviceIds: deviceIds.controllerIds
        })
    });


    if (!response.ok) {
        let errorMsg = `Server Error: ${response.status}`;
        try {

            const errorData = await response.json();
            errorMsg = errorData.message || errorData.error || errorMsg;
        } catch (e) {
            console.error("Could not parse error response JSON", e);
        }
        throw new Error(errorMsg);
    }


    const data = await response.json();


    if (data && data.body && typeof data.body === 'string') {
        try {
            return JSON.parse(data.body);
        } catch (e) {
            return data;
        }
    }

    return data;
};

export const useScheduledSettingsTrigger = () => {
    return useMutation({
        mutationFn: triggerScheduledSettings,
        onSuccess: (data) => {
            console.log("Batch processed successfully:", data);
        },
        onError: (error) => {
            console.error("Error triggering settings:", error);
        }
    });
};